const showErrorModal = (state, message) => {
  state.isShow = true
  state.status = 'error'
  state.message = message
}

const showSuccessModal = (state, message) => {
  state.isShow = true
  state.status = 'success'
  state.message = message
}

const showModal = (state, data) => {
  state.isShow = true
  state.status = data.status
  state.message = data.message
  state.message = data.timeout === undefined ? 5000 : data.timeout
}

const clearModalState = (state, isShow) => {
  state.isShow = isShow
}

export default {
  showErrorModal, showSuccessModal, showModal, clearModalState
}
